import { c as _c } from "react-compiler-runtime";
import { memo } from 'react';
import { COMMENT_INDICATOR_IDENTIFIER } from 'collaboration-sidebar/constants/identifiers';
import { View } from 'foundations-components/transitional/components/View';
import EmbeddedCommentIndicator from './EmbeddedCommentIndicator';
import { jsx as _jsx } from "react/jsx-runtime";
function EmbeddedComment(t0) {
  "use memo";

  const $ = _c(22);
  const {
    onClose,
    collaborationSidebarState,
    verticalPositioning,
    setIsCommenting,
    iconPosition: t1,
    iconProps,
    renderCommentIndicator,
    moduleParentComment,
    topOffset,
    leftOffset,
    isOpen,
    embeddedCommentWrapperRef,
    toggleOpenPopover
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? {} : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const iconPosition = t2;
  const t3 = iconPosition.top || `${topOffset}px`;
  const t4 = iconPosition.left || `${leftOffset}px`;
  const t5 = iconPosition.bottom;
  const t6 = iconPosition.right;
  let t7;
  if ($[2] !== iconPosition) {
    t7 = Object.keys(iconPosition);
    $[2] = iconPosition;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  const t8 = t7.length > 0;
  let t9;
  if ($[4] !== collaborationSidebarState || $[5] !== embeddedCommentWrapperRef || $[6] !== iconProps || $[7] !== isOpen || $[8] !== moduleParentComment || $[9] !== onClose || $[10] !== renderCommentIndicator || $[11] !== setIsCommenting || $[12] !== t8 || $[13] !== toggleOpenPopover || $[14] !== verticalPositioning) {
    t9 = /*#__PURE__*/_jsx(EmbeddedCommentIndicator, {
      collaborationSidebarState: collaborationSidebarState,
      isOpen: isOpen,
      onClose: onClose,
      iconProps: iconProps,
      renderCommentIndicator: renderCommentIndicator,
      setIsCommenting: setIsCommenting,
      verticalPositioning: verticalPositioning,
      hasCustomPosition: t8,
      moduleParentComment: moduleParentComment,
      embeddedCommentWrapperRef: embeddedCommentWrapperRef,
      toggleOpenPopover: toggleOpenPopover
    });
    $[4] = collaborationSidebarState;
    $[5] = embeddedCommentWrapperRef;
    $[6] = iconProps;
    $[7] = isOpen;
    $[8] = moduleParentComment;
    $[9] = onClose;
    $[10] = renderCommentIndicator;
    $[11] = setIsCommenting;
    $[12] = t8;
    $[13] = toggleOpenPopover;
    $[14] = verticalPositioning;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== iconPosition.bottom || $[17] !== iconPosition.right || $[18] !== t3 || $[19] !== t4 || $[20] !== t9) {
    t10 = /*#__PURE__*/_jsx(View, {
      id: COMMENT_INDICATOR_IDENTIFIER,
      position: "absolute",
      insetBlockStart: t3,
      insetInlineStart: t4,
      insetBlockEnd: t5,
      insetInlineEnd: t6,
      children: t9
    });
    $[16] = iconPosition.bottom;
    $[17] = iconPosition.right;
    $[18] = t3;
    $[19] = t4;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  return t10;
}
export default /*#__PURE__*/memo(EmbeddedComment);